<!--
    @name: 级联选择器样式重写
    @description: 默认展示级联选择器示例，
                  原生JS创建样式节点全局覆盖样式，组件销毁清空，避免污染
    @author: 徐朝成 xcc614@qq.com
    @time: 2021-12-08 15:48:05
-->
<template>
  <div>
    <el-cascader v-bind="$attrs" v-on="$listeners">
      <slot></slot>
    </el-cascader>
  </div>
</template>

<script>
export default {
  name: "ui-cascader",
  inheritAttrs: false,
  data(){
    let style=document.createElement('style')
    style.id='ui-cascader'
    style.innerText='.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{color: var(--Czsd);}'
    return {
      el:style,
    }
  },
  created() {
    window.uiCascaderNumber=window.uiCascaderNumber?++window.uiCascaderNumber:1
    if(document.getElementById('ui-cascader')){
      return
    }
    document.body.appendChild(this.el)
  },
  destroyed() {
    --window.uiCascaderNumber;
    if(document.getElementById('ui-cascader')&&!window.uiCascaderNumber){
      document.body.removeChild(document.getElementById('ui-cascader'))
    }
  }
}
</script>

<style scoped lang="scss">
/deep/.el-cascader{
  font-size: 50px !important;
}
/deep/.el-cascader .el-input .el-input__inner:focus,{
  border-color: var(--Czsd);
}
/deep/ .el-cascader .el-input.is-focus .el-input__inner{
  border-color: var(--Czsd);
}
</style>
